import React, { useState, useRef, useEffect } from "react";

const LeagueDropdown = ({ leagueData, leagueId, handleLeagueChange }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const dropdownRef = useRef(null);

  const filteredLeagues = leagueData.filter((item) =>
    item.leaguename.toLowerCase().includes(searchTerm.toLowerCase())
  );

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleSelect = (id) => {
    handleLeagueChange({ target: { value: id } });
    setIsOpen(false);
    setSearchTerm("");
  };


  return (
    <div className="AF-select" ref={dropdownRef}>
      {/* Selected value */}
      <div
        className="dropdown-text-bet"
        onClick={() => setIsOpen(!isOpen)}
      >
        {leagueData.length > 0 ? leagueData.find((item) => String(item.leagueid) === String(leagueId))?.leaguename || "Select league"
        : "Select league"}
      </div>

      {isOpen && (
        <div className="dropdown-list" style={{color:'black'}}>
          {/* Search inside dropdown */}
          <div className="AF-formControl_tribet">
          <input
            type="text"
            placeholder="Search..."
            className="w-full p-2 border-b outline-none"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            autoFocus
          />
          </div>

            {filteredLeagues.length > 0 ? (
              filteredLeagues.map((item) => (
                <div key={item.leagueid} className="AF-formControl_multibet"
                  onClick={() => handleSelect(item.leagueid)}
                >
                  {item.leaguename}
                </div>
              ))
            ) : (
              <div className="message" style={{textAlign:'center'}}>League not available</div>
            )}
        </div>
      )}
    </div>
  );
};

export default LeagueDropdown;
